




import Vue from "vue"
export default Vue.extend({
  mounted() {
    this.$errorRenderer.notFound()
  },
})
